/* eslint-disable @next/next/no-img-element */
import React from "react";
import ChippyPromptWrapper from "./ChippyPromptWrapper";

const ChippyPrompt = () => {
  return (
    <ChippyPromptWrapper>
      <>
        <p>Hi! Allow me to introduce myself, my name is Chippy.</p>
        <p>How can I help?</p>
        <a href="https://chrome.google.com/webstore/detail/chippy-%E2%80%94-chatgpt-at-your/fbcdphjbmledkhefgamfaleobmegjojl">
          Add Extension
        </a>
        <svg
          width="29px"
          height="10px"
          viewBox="0 0 29 10"
          className="message-arrow"
        >
          <title>Submit Message</title>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              id="Rectangle-18"
              transform="translate(0.468300, 0.000000)"
              fill="currentColor"
              fillRule="nonzero"
            >
              <path d="M27.8577,0 C23.2594,0 19.5317,3.728 19.5317,8.326 C19.5317,8.944 18.7847,9.254 18.3475,8.817 L16.2597,6.731 C11.946,2.421 6.0977,0 0,0 C6.47068611,0 11.3237007,0 14.5590438,0 C17.5143007,0 21.9471861,0 27.8577,0 Z" />
            </g>
          </g>
        </svg>
      </>
    </ChippyPromptWrapper>
  );
};

export default ChippyPrompt;
